var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 503,
    viewBox: "0 0 503 503",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ver 3 get strated illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(-5679 -1346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ver 3 get strated illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ver 3 get strated illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path 5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_stroke",
    transform: "translate(5697 1349)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_stroke",
    transform: "translate(5923 1460)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_stroke",
    transform: "translate(5808 1604)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 9"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_stroke",
    transform: "translate(5839 1348)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 10"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path4_stroke",
    transform: "translate(5697 1570)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path5_stroke",
    transform: "translate(5697 1347)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 12"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path6_stroke",
    transform: "translate(5708 1389)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 13"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path7_stroke",
    transform: "translate(5932 1600)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 14"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8_stroke",
    transform: "translate(5808 1711)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 15"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path9_stroke",
    transform: "translate(5809 1750)",
    fill: "#979797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(5835 1426)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_stroke",
    transform: "translate(5826 1417)",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(6165 1706)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_stroke",
    transform: "translate(6156 1697)",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(6086 1567)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_stroke",
    transform: "translate(6077 1558)",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(5805 1746)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_stroke",
    transform: "translate(5796 1737)",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path10_fill",
    transform: "translate(5855 1832)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path11_stroke",
    transform: "translate(5846 1823)",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path12_fill",
    transform: "translate(5995 1816)",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path12_fill",
    transform: "translate(5705 1387)",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path12_fill",
    transform: "translate(5966 1346)",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(5692 1565)",
    fill: "#FF7E00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path14_stroke",
    transform: "translate(5680 1553)",
    fill: "#FF7E00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(5692 1735)",
    fill: "#FF7E00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path14_stroke",
    transform: "translate(5680 1723)",
    fill: "#FF7E00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(6032 1705)",
    fill: "#FF7E00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path14_stroke",
    transform: "translate(6020 1693)",
    fill: "#FF7E00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path13_fill",
    transform: "translate(6122 1455)",
    fill: "#FF7E00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval 2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path14_stroke",
    transform: "translate(6110 1443)",
    fill: "#FF7E00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3094"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path15_fill",
    transform: "translate(5841 1517)",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path16_stroke",
    transform: "translate(5841 1517)",
    fill: "#F7931A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3096"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path17_fill",
    transform: "translate(5879.74 1544.79)",
    fill: "#FFFFFF"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_stroke",
    d: "M 433 111L 433.494 110.923L 433.409 110.381L 432.878 110.515L 433 111ZM 0 220L -0.122058 219.515L -0.0725571 220.495L 0 220ZM 225 253L 224.927 253.495L 225.402 253.564L 225.491 253.093L 225 253ZM 472.494 359.923L 433.494 110.923L 432.506 111.077L 471.506 360.077L 472.494 359.923ZM 432.878 110.515L -0.122058 219.515L 0.122058 220.485L 433.122 111.485L 432.878 110.515ZM -0.0725571 220.495L 224.927 253.495L 225.073 252.505L 0.0725571 219.505L -0.0725571 220.495ZM 225.491 253.093L 273.491 0.0931991L 272.509 -0.0931991L 224.509 252.907L 225.491 253.093Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_stroke",
    d: "M 76 360L 75.5279 360.165L 75.9917 361.495L 76.4703 360.17L 76 360ZM -0.472131 142.165L 75.5279 360.165L 76.4721 359.835L 0.472131 141.835L -0.472131 142.165ZM 76.4703 360.17L 206.47 0.169822L 205.53 -0.169822L 75.5297 359.83L 76.4703 360.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_stroke",
    d: "M 0 145L -0.391749 144.689L -0.818824 145.228L -0.175021 145.468L 0 145ZM 114.608 -0.310697L -0.391749 144.689L 0.391749 145.311L 115.392 0.310697L 114.608 -0.310697ZM -0.175021 145.468L 189.825 216.468L 190.175 215.532L 0.175021 144.532L -0.175021 145.468Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_stroke",
    d: "M 0 81L -0.258655 80.5721L -0.645348 80.8058L -0.451816 81.2142L 0 81ZM 82.4518 253.786L 0.451816 80.7858L -0.451816 81.2142L 81.5482 254.214L 82.4518 253.786ZM 0.258655 81.4279L 134.259 0.427899L 133.741 -0.427899L -0.258655 80.5721L 0.258655 81.4279Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4_stroke",
    d: "M 113 180L 112.96 180.498L 113.953 180.577L 113.423 179.734L 113 180ZM 0 171L -0.5 171L -0.5 171.462L -0.0396973 171.498L 0 171ZM 0 0L 0.42347 -0.265845L -0.5 -1.73686L -0.5 0L 0 0ZM 113.04 179.502L 0.0396973 170.502L -0.0396973 171.498L 112.96 180.498L 113.04 179.502ZM 0.5 171L 0.5 0L -0.5 0L -0.5 171L 0.5 171ZM -0.42347 0.265845L 112.577 180.266L 113.423 179.734L 0.42347 -0.265845L -0.42347 0.265845Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5_stroke",
    d: "M 271.5 0L 271.788 -0.408837L 271.062 0.240312L 271.5 0ZM 471 364L 471.274 364.418L 471.661 364.165L 471.438 363.76L 471 364ZM 303 474L 302.681 474.385L 302.965 474.62L 303.274 474.418L 303 474ZM 0 223L -0.353553 222.646L -0.741846 223.035L -0.318966 223.385L 0 223ZM 142 81L 142.327 80.6214L 141.975 80.318L 141.646 80.6464L 142 81ZM 432.288 112.591L 271.788 -0.408837L 271.212 0.408837L 431.712 113.409L 432.288 112.591ZM 271.062 0.240312L 470.562 364.24L 471.438 363.76L 271.938 -0.240312L 271.062 0.240312ZM 470.726 363.582L 302.726 473.582L 303.274 474.418L 471.274 364.418L 470.726 363.582ZM 303.319 473.615L 0.318966 222.615L -0.318966 223.385L 302.681 474.385L 303.319 473.615ZM 0.353553 223.354L 142.354 81.3536L 141.646 80.6464L -0.353553 222.646L 0.353553 223.354ZM 141.673 81.3786L 469.673 364.379L 470.327 363.621L 142.327 80.6214L 141.673 81.3786Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6_stroke",
    d: "M 132.148 40.5225L 0.148313 -0.477497L -0.148313 0.477497L 131.852 41.4775L 132.148 40.5225Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7_stroke",
    d: "M 106 111L 105.638 111.345L 105.786 111.5L 106 111.5L 106 111ZM 238 110.5L 106 110.5L 106 111.5L 238 111.5L 238 110.5ZM 106.362 110.655L 0.361604 -0.345315L -0.361604 0.345315L 105.638 111.345L 106.362 110.655Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8_stroke",
    d: "M 0.0821995 39.4932L 234.082 0.493197L 233.918 -0.493197L -0.0821995 38.5068L 0.0821995 39.4932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9_stroke",
    d: "M -0.430967 0.25351L 49.569 85.2535L 50.431 84.7465L 0.430967 -0.25351L -0.430967 0.25351Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10_fill",
    fillRule: "evenodd",
    d: "M 3.5 7C 5.433 7 7 5.433 7 3.5C 7 1.567 5.433 0 3.5 0C 1.567 0 0 1.567 0 3.5C 0 5.433 1.567 7 3.5 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11_stroke",
    d: "M 12.5 25.5C 19.6797 25.5 25.5 19.6797 25.5 12.5L 24.5 12.5C 24.5 19.1274 19.1274 24.5 12.5 24.5L 12.5 25.5ZM 25.5 12.5C 25.5 5.3203 19.6797 -0.5 12.5 -0.5L 12.5 0.5C 19.1274 0.5 24.5 5.87258 24.5 12.5L 25.5 12.5ZM 12.5 -0.5C 5.3203 -0.5 -0.5 5.3203 -0.5 12.5L 0.5 12.5C 0.5 5.87258 5.87258 0.5 12.5 0.5L 12.5 -0.5ZM -0.5 12.5C -0.5 19.6797 5.3203 25.5 12.5 25.5L 12.5 24.5C 5.87258 24.5 0.5 19.1274 0.5 12.5L -0.5 12.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12_fill",
    fillRule: "evenodd",
    d: "M 4 8C 6.20914 8 8 6.20914 8 4C 8 1.79086 6.20914 0 4 0C 1.79086 0 0 1.79086 0 4C 0 6.20914 1.79086 8 4 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13_fill",
    fillRule: "evenodd",
    d: "M 5.5 11C 8.53757 11 11 8.53757 11 5.5C 11 2.46243 8.53757 0 5.5 0C 2.46243 0 0 2.46243 0 5.5C 0 8.53757 2.46243 11 5.5 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14_stroke",
    d: "M 17.5 35.5C 27.4411 35.5 35.5 27.4411 35.5 17.5L 34.5 17.5C 34.5 26.8888 26.8888 34.5 17.5 34.5L 17.5 35.5ZM 35.5 17.5C 35.5 7.55887 27.4411 -0.5 17.5 -0.5L 17.5 0.5C 26.8888 0.5 34.5 8.11116 34.5 17.5L 35.5 17.5ZM 17.5 -0.5C 7.55887 -0.5 -0.5 7.55887 -0.5 17.5L 0.5 17.5C 0.5 8.11116 8.11116 0.5 17.5 0.5L 17.5 -0.5ZM -0.5 17.5C -0.5 27.4411 7.55887 35.5 17.5 35.5L 17.5 34.5C 8.11116 34.5 0.5 26.8888 0.5 17.5L -0.5 17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15_fill",
    d: "M 157.605 99.353C 146.919 142.21 103.507 168.292 60.6401 157.605C 17.7905 146.92 -8.29473 103.51 2.39641 60.6559C 13.0775 17.7938 56.4897 -8.29093 99.3442 2.39397C 142.209 13.0789 168.292 56.4934 157.605 99.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16_stroke",
    d: "M 157.605 99.353L 158.091 99.474L 158.091 99.4739L 157.605 99.353ZM 60.6401 157.605L 60.5191 158.09L 60.5192 158.09L 60.6401 157.605ZM 2.39641 60.6559L 2.88154 60.7769L 2.88157 60.7768L 2.39641 60.6559ZM 99.3442 2.39397L 99.2233 2.87911L 99.2233 2.87912L 99.3442 2.39397ZM 157.12 99.232C 146.501 141.821 103.36 167.74 60.7611 157.12L 60.5192 158.09C 103.654 168.844 147.338 142.599 158.091 99.474L 157.12 99.232ZM 60.7611 157.12C 18.1794 146.502 -7.74274 103.363 2.88154 60.7769L 1.91128 60.5348C -8.84672 103.657 17.4017 147.338 60.5191 158.09L 60.7611 157.12ZM 2.88157 60.7768C 13.4959 18.1827 56.6367 -7.73897 99.2233 2.87911L 99.4652 1.90882C 56.3427 -8.84288 12.6592 17.4049 1.91124 60.535L 2.88157 60.7768ZM 99.2233 2.87912C 141.82 13.4972 167.74 56.6404 157.12 99.232L 158.091 99.4739C 168.844 56.3465 142.598 12.6605 99.4652 1.90881L 99.2233 2.87912Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17_fill",
    fillRule: "evenodd",
    d: "M 58.814 20.6616L 62.4136 6.15796L 53.625 3.95776L 50.1206 18.0792C 47.8101 17.5009 45.437 16.9552 43.0791 16.4146L 46.6089 2.2002L 37.8252 0L 34.2231 14.4985C 32.3105 14.061 30.4331 13.6285 28.6108 13.1735L 16.501 10.0881L 14.1631 19.5175C 14.1631 19.5175 20.6836 21.0187 20.5459 21.1117C 24.1055 22.0043 24.7485 24.3705 24.6411 26.2462L 20.541 42.769C 20.7861 42.8318 21.104 42.9224 21.4546 43.0632L 21.1641 42.9904C 20.958 42.9384 20.7441 42.8845 20.5259 42.8319L 14.7788 65.9778C 14.3433 67.064 13.2393 68.6934 10.751 68.0748C 10.8389 68.2031 4.36279 66.4731 4.36279 66.4731L 0 76.5789L 11.437 79.4429C 12.6968 79.76 13.9419 80.0862 15.1743 80.4089L 15.2329 80.4242C 16.0615 80.6414 16.8848 80.8569 17.7021 81.0673L 14.0654 95.7367L 22.8438 97.9369L 26.4458 83.4233C 28.8438 84.077 31.1719 84.6805 33.4497 85.2488L 29.8604 99.6946L 38.6489 101.895L 42.2856 87.2528C 57.272 90.1018 68.5415 88.9526 73.2847 75.3367C 77.1069 64.3735 73.0947 58.0496 65.2095 53.9258C 70.9517 52.5956 75.2773 48.8013 76.4312 40.9636C 78.0259 30.2568 69.9106 24.5012 58.814 20.6616ZM 29.3018 72.7996L 34.1279 53.3651C 34.7202 53.5137 35.4429 53.6766 36.2603 53.861L 36.2871 53.8671C 43.7041 55.5388 58.9043 58.9651 56.3511 69.2491C 53.8589 79.3074 38.186 75.149 31.0151 73.2463C 30.3701 73.0752 29.7935 72.9222 29.3018 72.7996ZM 40.7114 26.8422L 36.3359 44.4688C 36.7495 44.5723 37.2344 44.7023 37.7778 44.8479C 43.7568 46.4508 56.7979 49.9468 59.0698 40.8052C 61.3896 31.4545 48.7144 28.6359 42.5239 27.2592C 41.8271 27.1044 41.2129 26.9678 40.7114 26.8422Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/Bitcoin.a4763580f727ae123f50361defb9d382.svg";
export { ForwardRef as ReactComponent };